import { React, useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../pages/home";
import QuickInfo from "../pages/quickInfo";
import RoomStatus from "../pages/roomStatus";
import Documents from "../pages/document";
import Notification from "../pages/notification";
import Cart from "../pages/cart";
import Account from "../pages/account";
import Users from "../pages/users";
import ChangePassword from "../pages/changePassword";
import WeddingCalendar from "../pages/weddingCalendar";
import NewRoomStatus from "../pages/newRoomStatus";
import Picture from "../pages/picture";
import Video from "../pages/video";
import Blog from "../pages/blog";
import Post from "../pages/post";
import NewsLetter from "../pages/newsletter";
import LUpdate from "../pages/lUpdate";
import LUpdateViewer from "../pages/lUpdateViewer";
import Mauritius from "../pages/mauritius";
import SharedCart from "../pages/sharedCart";
import PageNotFound from "../pages/pageNotFound";
import Header from "../components/layouts/header";
import SideBar from "../components/layouts/sideBar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "../components/layouts/footer";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { userTitles } from "../components/constant";
import { LoadingTemplate } from "../components/helpful";
import { Dialog } from "primereact/dialog";
import {
  storeHotels,
  storeSeasonality,
  addCart,
  setSession,
  signOut,
} from "../store/reducer";

import {
  getHotels,
  getGalerieImages,
  getUser,
  getSeasonality,
  getDestination,
  getCart,
  checkSession,
} from "../api/api";
import { useDispatch } from "react-redux";
import { documentRoutes } from "../components/constant";
import { deepComparison } from "../components/utilities";

import LoginForm from "../components/loginForm";
/**
 * This component renders the main routes of the application.
 * It fetches the user data, hotels, seasonality, and slide images.
 * It renders the Header, SideBar, and the main content based on the route.
 * If the data is still loading, it renders a loading template.
 * If the user is not logged in, it renders a login page.
 * @returns {JSX.Element} The main routes of the application.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com>
 */

export default function HomeRoutes() {
  const location = useLocation();
  const app = useSelector((state) => state.user);
  const session = app.sessionActive ;
  const cart = useSelector((state) => state.cart.cart);
  const isDownloading = useSelector((state) => state.cart.isDownloading);
  const menu = useSelector((state) => state.menu);
  const notificationRoutes = menu.dynamicRoutes;
  const latestDocs = useSelector((state) => state.appState.latestDocuments);
  const unread_nb = useSelector((state) => state.appState.unread_nb);
  const dispatch = useDispatch();
  const [hotels, setHotels] = useState([]);
  const [mauritius, setMauritius] = useState();
  const [category, setCategory] = useState(menu.activeItem);

  const userID = app.userID;
  const [user, setUser] = useState({});
  const [slideInfo, setSlideInfo] = useState({});
  const [visible, setVisible] = useState(false);

  const { data: userSession } = useQuery({
    queryKey: ["userSession", userID],
    queryFn: () => checkSession(userID),
    staleTime: 0, 
    cacheTime: 1000 * 60 * 30, 
    refetchInterval: 1000 * 60 * 30, 
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  });

  const { data, isLoading, error } = useQuery({
    queryKey: ["hotels", userID],
    queryFn: getHotels,
    staleTime: Infinity, // This ensures the data is never considered stale and won't be refetched.
  });
  const { data: userCart } = useQuery({
    queryKey: ["userCart", userID],
    queryFn: () => getCart(userID),
  });

  const { data: seasons, isLoading: isSeasonLoading } = useQuery({
    queryKey: ["seasons", "en"],
    queryFn: () => getSeasonality("en"),
    cacheTime: 1000 * 60 * 60,
  });

  const { data: mauritius_data, isLoading: ismauritius_dataLoading } = useQuery(
    {
      queryKey: ["mauritius", "en"],
      queryFn: () => getDestination("en"),
      cacheTime: 1000 * 60 * 60,
    }
  );

  const { data: slideImages, isLoading: isFetching } = useQuery({
    queryKey: ["slide_image", userID],
    queryFn: () => getGalerieImages("en"),
    // cacheTime: 1000 * 60 * 60,
  });

  useEffect(() => {
    if (userCart) {
      userCart.forEach((item) => {
        const isIncluded = cart.find((elt) => deepComparison(elt, item));

        if (isIncluded) {
          return;
        }
        dispatch(addCart(item));
      });
    }
  }, [userCart]);

 

  useEffect(() => {
    
    if(!userSession?.result){
      setSession(true)
    }else{
      setSession(false)
    }

  }, [app.isLoggedIn, userSession?.result]);

  useEffect(() => {
    
    if (!session) {
      setVisible(true);

    }
  }, [session]);

  useEffect(() => {
    if (slideImages) {
      setSlideInfo(slideImages);
    }
  }, [slideImages, slideInfo]);

  useEffect(() => {
    setCategory(menu.activeItem);
  }, [menu.activeItem]);

  // useEffect for fetching user data
  useEffect(() => {
    const fetchUser = async () => {
      const resp = await getUser(userID);
      setUser(resp);
    };
    fetchUser();
  }, [userID]);

  // useEffect for processing data and storing hotels
  useEffect(() => {
    if (data) {
      dispatch(storeHotels(data));
      setHotels(data);
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (seasons && seasons.length > 0) {
      dispatch(storeSeasonality(seasons));
    }
  }, [seasons, dispatch]);

  useEffect(() => {
    if (mauritius_data) {
      setMauritius(mauritius_data);
    }
  }, [mauritius_data]);

  
  if (
    isFetching ||
    isLoading ||
    isSeasonLoading ||
    Object.keys(slideInfo).length === 0 ||
    Object.keys(user).length === 0
  )
    return (
      <div>
        <LoadingTemplate />
      </div>
    );

  return (
    <>
      <div>
        <Dialog
          visible={visible}
          className=""
          modal
          onHide={() => {
            if (!visible) return;
            setVisible(false);
          }}
          style={{
            width: "20vw",
            position: "relative",
            top: "0vh",
           
            left: "17vh",
            transform: "translate(-50%, -50%)"
          }}
          breakpoints={{ "960px": "50vw", "641px": "75vw" }}
          content={({ hide }) => (
            <div
              className="flex flex-column   p-4 "
              style={{ backgroundColor: "white" }}
            >
              <div className="py-3 text-center">
              <h6 >
                Your session has expired.
              </h6>
             
              </div>
              

              <LoginForm expire={true} callback={() => setVisible(false)} />
            </div>
          )}
        ></Dialog>
        <Row className="g-0">
          <Col sm={3} className="sidebar">
            <Header />
            <SideBar />
          </Col>
          <Col sm={9} className="main">
            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    user={user}
                    slideImages={slideInfo}
                    isDownloading={isDownloading}
                  />
                }
              />
              <Route exact path="/shared-cart/*" element={<SharedCart />} />
              {notificationRoutes && notificationRoutes.length > 0
                ? notificationRoutes.map((item) => (
                    <Route
                      key={item}
                      exact
                      path={item.url}
                      element={
                        <Notification
                          files={[latestDocs]}
                          id={item.id}
                          userID={userID}
                          unread_nb={unread_nb}
                        />
                      }
                    />
                  ))
                : null}
              <Route
                exact
                path={"/notifications"}
                element={
                  <Notification
                    files={[latestDocs]}
                    id={0}
                    userID={userID}
                    unread_nb={unread_nb}
                  />
                }
              />
              <Route
                exact
                path="/mauritius"
                element={
                  <Mauritius
                    data={mauritius}
                    isLoading={ismauritius_dataLoading}
                  />
                }
              />
              <Route exact path="/quick-info/*" element={<QuickInfo />} />
              <Route
                exact
                path="/room-status/*"
                element={<RoomStatus hotels={hotels} />}
              />

              {documentRoutes.map((route, index) => {
                let userStats = [];
                for (let item in app.user.statUsers) {
                  userStats.push(app.user.statUsers[item]);
                }

                let statRoute = ["/monthly-statistics", "/forward-bookings"]; 

                if (statRoute.includes(route) && !userStats.includes(userID)) {
                  return null;
                } else {
                  return (
                    <Route
                      key={index}
                      exact
                      path={route}
                      element={<Documents category={category} />}
                    />
                  );
                }
              })}

              <Route
                exact
                path="/wedding-calendar"
                element={<WeddingCalendar hotels={hotels} />}
              />

              <Route
                exact
                path="/new-room-status"
                element={<NewRoomStatus />}
              />

              <Route exact path="/cart" element={<Cart />} />
              <Route
                exact
                path="/notification"
                element={<Notification unread_nb={unread_nb} />}
              />
              <Route
                exact
                path="/my-account"
                element={
                  <Account
                    countries={app.countries}
                    titles={userTitles}
                    user={user}
                  />
                }
              />
              <Route
                exact
                path="/users"
                element={
                  <Users
                    userID={userID}
                    userGroupID={app.user.userGroupID}
                    countries={app.countries}
                    userGroups={app.userTypes}
                    hotels={app.hotels}
                    markets={app.markets}
                    titles={userTitles}
                  />
                }
              />
              <Route
                exact
                path="/change-password"
                element={<ChangePassword user={user} />}
              />

              <Route
                exact
                path="/pictures"
                element={<Picture parentID={menu.activeMenuItem} />}
              />
              <Route exact path="/videos" element={<Video />} />

              <Route exact path="/blog" element={<Blog />} />
              <Route exact path="/blog/:id" element={<Post />} />
              <Route exact path="/newsletter-b2b" element={<NewsLetter />} />
              <Route exact path="/l-update" element={<LUpdate />} />
              <Route
                exact
                path="/l-update-viewer"
                element={<LUpdateViewer />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
            <div className="main-footer">
              <Footer islogin={true} />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
